export default __webpack_public_path__ + "static/media/success.cb695530.png";